import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "box-empty"
}
const _hoisted_3 = { class: "certificates" }
const _hoisted_4 = {
  key: 0,
  class: "item"
}
const _hoisted_5 = { class: "item-content" }
const _hoisted_6 = { class: "form" }
const _hoisted_7 = { class: "flex flex-row gap-4" }
const _hoisted_8 = { class: "images" }
const _hoisted_9 = ["src", "alt", "onClick"]
const _hoisted_10 = { class: "actions" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "upload" }
const _hoisted_13 = { class: "flex flex-row justify-end w-full" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "box-add" }

import { computed, onMounted, ref } from "vue";
import { debounce } from "lodash-es";
import { useI18n } from "vue-i18n";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import { PDFtoIMG } from "@/common/services/convert";

import { fileCreate, fileDelete } from "@/common/api/rest/file/file";
import {
  certificateList,
  certificateCreate,
  certificatePatch,
  certificateDelete,
} from "@/common/api/rest/certificate";

import type { FileType } from "@/common/types/common";
import type { CertificateType } from "@/common/types/certificate";

import { fileUploadForm, viewImage } from "@/components";
import {
  baseConfirm,
  baseInput,
  baseDate,
  baseSelect,
  baseTextarea,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'equipment-certificates',
  props: {
    accountId: {},
    equipmentId: {},
    width: { default: "100%" },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;
const fileExtensions = [".bmp", ".jpg", ".jpeg", ".pdf"];

const certificates = ref<CertificateType[]>([]);
const selected = ref<CertificateType | null>(null);
const selectedImageId = ref<string | null>(null);
const showImage = ref<string | null>(null);

const showConfirmDel = ref(false);
const showConfirmImageDel = ref(false);

const fileKey = ref(1);

const statusOptions = computed(() => [
  {
    option: t("common.labels.active"),
    value: "ACTIVE",
  },
  {
    option: t("common.labels.inactive"),
    value: "INACTIVE",
  },
]);

function fecthCertificates() {
  if (!props.equipmentId) return;

  certificateList(props.accountId, props.equipmentId)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        certificates.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update(index: number, key: keyof CertificateType) {
  const certificate = certificates.value[index];

  certificatePatch(props.accountId, certificate.certificate_id, {
    [key]: certificate[key],
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fecthCertificates();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addCertificate() {
  if (!props.equipmentId) return;

  certificateCreate(props.accountId, props.equipmentId)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fecthCertificates();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function delCertificate(index: number) {
  selected.value = certificates.value[index];
  showConfirmDel.value = true;
}

function delCertificateCancel() {
  selected.value = null;
  showConfirmDel.value = false;
}

function delCertificateConfirm() {
  if (!selected.value) return;

  showConfirmDel.value = false;
  certificateDelete(props.accountId, selected.value.certificate_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fecthCertificates();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function uploadFile(index: number, fileData: FileType) {
  const { extension, name, file, infos } = fileData;

  const certificate = certificates.value[index];

  if (extension?.toLowerCase() === "pdf") {
    const converted = await PDFtoIMG(file);

    if (!converted.success) {
      store.commit("SET_LOADING", false);
      toast({ message: t("error.default"), type: "error" });
      return;
    }

    if (!converted.pages?.length) {
      store.commit("SET_LOADING", false);
      fileKey.value++;
      return;
    }

    const promises = converted.pages.map((item) =>
      fileCreate(props.accountId, certificate.certificate_id, {
        file: item.image.split(",")[1],
        type: "CERTIFICATE",
        name,
        extension: "jpg",
        page: item.page,
        infos: item.image.split(",")[0],
      }),
    );

    await Promise.all(promises).finally(() => {
      store.commit("SET_LOADING", false);
      fileKey.value++;
      fecthCertificates();
    });
  } else if (extension?.toLowerCase() === "jpg") {
    await fileCreate(props.accountId, certificate.certificate_id, {
      file: file,
      type: "CERTIFICATE",
      name,
      extension: "jpg",
      page: 0,
      infos: infos,
    }).finally(() => {
      store.commit("SET_LOADING", false);
      fileKey.value++;
      fecthCertificates();
    });
  } else {
    toast({ message: t("error.file_not_supported"), type: "error" });
    store.commit("SET_LOADING", false);
    fileKey.value++;
  }
}

function removeImage(index: number, file_id?: string) {
  if (!file_id) return;

  const certificate = certificates.value[index];

  selected.value = certificate;
  selectedImageId.value = file_id;
  showConfirmImageDel.value = true;
}

function removeImageCancel() {
  selected.value = null;
  selectedImageId.value = null;
  showConfirmImageDel.value = false;
}

function removeImageConfirm() {
  if (!selected.value || !selectedImageId.value) return;

  showConfirmImageDel.value = false;
  store.commit("SET_LOADING", true);

  fileDelete(props.accountId, selectedImageId.value)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        removeImageCancel();
        fecthCertificates();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

const debounceUpdate = debounce(update, 1000);

onMounted(() => {
  fecthCertificates();
});

return (_ctx: any,_cache: any) => {
  const _component_templete = _resolveComponent("templete")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: _normalizeClass(["tab-component", { width: __props.width }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (certificates.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_unref(t)("equipment.texts.equipment_empty")) + " ", 1),
              _createElementVNode("button", {
                class: "btn btn-md btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addCertificate()))
              }, _toDisplayString(_unref(t)("common.labels.add", {
                concat: _unref(t)("common.labels.certificate"),
              }).toUpperCase()), 1)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(certificates.value, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.certificate_id
                  }, [
                    item
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_unref(baseSelect), {
                                class: "flex-2",
                                modelValue: item.status,
                                "onUpdate:modelValue": ($event: any) => ((item.status) = $event),
                                value: item.status,
                                options: statusOptions.value,
                                "is-empty": false,
                                onChange: ($event: any) => (update(index, 'status'))
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.status")) + " * ", 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onUpdate:modelValue", "value", "options", "onChange"]),
                              _createVNode(_unref(baseInput), {
                                class: "flex-3",
                                modelValue: item.name,
                                "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                                value: item.name,
                                required: "",
                                onInput: ($event: any) => (_unref(debounceUpdate)(index, 'name'))
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onUpdate:modelValue", "value", "onInput"]),
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_unref(baseDate), {
                                  modelValue: item.start_date,
                                  "onUpdate:modelValue": [($event: any) => ((item.start_date) = $event), ($event: any) => (_unref(debounceUpdate)(index, 'start_date'))],
                                  value: item.start_date,
                                  required: true,
                                  "value-mask": "YYYY-MM-DD",
                                  placeholder: "--/--/----"
                                }, {
                                  label: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.date")) + " * ", 1)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onUpdate:modelValue", "value"]),
                                _createVNode(_unref(baseDate), {
                                  modelValue: item.end_date,
                                  "onUpdate:modelValue": [($event: any) => ((item.end_date) = $event), ($event: any) => (_unref(debounceUpdate)(index, 'end_date'))],
                                  value: item.end_date,
                                  required: true,
                                  "value-mask": "YYYY-MM-DD",
                                  placeholder: "--/--/----"
                                }, {
                                  label: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.validity")) + " * ", 1)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onUpdate:modelValue", "value"])
                              ]),
                              _createVNode(_unref(baseTextarea), {
                                modelValue: item.description,
                                "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                                value: item.description,
                                placeholder: _unref(t)('common.placeholders.describe'),
                                onInput: ($event: any) => (_unref(debounceUpdate)(index, 'description'))
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder", "onInput"])
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["certificate", {
                    'has-images': item.files,
                  }])
                            }, [
                              (item.files)
                                ? (_openBlock(), _createBlock(_component_templete, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_8, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.files, (image, img_idx) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: img_idx,
                                            class: "image"
                                          }, [
                                            _createElementVNode("img", {
                                              src: image.file,
                                              alt: `image ${img_idx + 1}`,
                                              onClick: ($event: any) => (showImage.value = image.file)
                                            }, null, 8, _hoisted_9),
                                            _createElementVNode("div", _hoisted_10, [
                                              _createElementVNode("button", {
                                                class: "btn btn-sm btn-default",
                                                onClick: ($event: any) => (removeImage(index, image.file_id))
                                              }, [
                                                _createVNode(_unref(svgIcon), {
                                                  icon: "trash",
                                                  size: "1.25rem"
                                                })
                                              ], 8, _hoisted_11)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_12, [
                                (_openBlock(), _createBlock(_unref(fileUploadForm), {
                                  key: fileKey.value,
                                  extensions: fileExtensions,
                                  onUpdateData: ($event: any) => (uploadFile(index, $event))
                                }, null, 8, ["onUpdateData"]))
                              ])
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("button", {
                              class: "btn btn-md btn-danger",
                              onClick: ($event: any) => (delCertificate(index))
                            }, [
                              _createVNode(_unref(svgIcon), {
                                icon: "trash",
                                size: "1.5rem"
                              }),
                              _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.delete", {
                      concat: _unref(t)("common.labels.certificate"),
                    })), 1)
                            ], 8, _hoisted_14)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  class: "btn btn-md btn-primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (addCertificate()))
                }, _toDisplayString(_unref(t)("common.labels.add", {
                concat: _unref(t)("common.labels.certificate"),
              }).toUpperCase()), 1)
              ])
            ], 64))
      ])
    ], 2),
    _createVNode(_unref(viewImage), {
      image: showImage.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (showImage.value = null))
    }, null, 8, ["image"]),
    _createVNode(_unref(baseConfirm), {
      "max-width": "400px",
      show: showConfirmDel.value,
      title: 
      _unref(t)('common.labels.remove', {
        concat: _unref(t)('common.labels.certificate'),
      }).toUpperCase()
    ,
      message: 
      _unref(t)('common.texts.remove_message', {
        concat: _unref(t)('common.labels.certificate').toUpperCase(),
      })
    ,
      onCancel: delCertificateCancel,
      onConfirm: delCertificateConfirm
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      "max-width": "400px",
      show: showConfirmImageDel.value,
      title: _unref(t)('common.modals.titles.remove_image').toUpperCase(),
      message: _unref(t)('common.modals.messages.remove_image'),
      onCancel: removeImageCancel,
      onConfirm: removeImageConfirm
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})